import Vue from 'vue';
import { gsap, ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

Vue.component('ticker-component', {
    props: {
        title: {
            type: String,
        },
        textColor: {
            type: String,
            required: false,
        },
        scrollTrigger: {
            type: Boolean,
            default: false,
        },
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            //
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        // The delayed call is needed because the font is still loading when initializing this.
        gsap.delayedCall(0.4, this.initTicker);

        // Listen.
        EventBus.$on('window-resize', this.resetTicker);
        EventBus.$on('header-scroll-down', this.setColorStyle);
        EventBus.$on('header-scroll-up', this.resetColorStyle);
        EventBus.$on('hero-video-play', this.onVideoPlay);
        EventBus.$on('hero-video-pause', this.onVideoPause);
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        resetColorStyle() {
            gsap.set(this.$el.querySelectorAll('.project-ticker__text'), {
                color: '',
            });
        },

        setColorStyle() {
            gsap.set(this.$el.querySelectorAll('.project-ticker__text'), {
                color: this.textColor,
            });

            gsap.to(this.tickerContainer, {
                duration: 0.5,
                autoAlpha: 1,
            });
        },

        onVideoPlay() {
            gsap.to(this.tickerContainer, {
                duration: 0.5,
                autoAlpha: 0,
            });
        },

        onVideoPause() {
            gsap.to(this.tickerContainer, {
                duration: 0.5,
                autoAlpha: 1,
            });
        },

        initTicker() {
            // Source: https://codepen.io/GreenSock/pen/QEdpLe
            this.tickerContainer = this.$el.querySelector('.project-ticker__container');
            this.tickerText = this.$el.querySelectorAll('.project-ticker__text');
            this.tickerWidth = this.tickerText[0].getBoundingClientRect().width;
            this.tickerTimeline = gsap.timeline({ paused: true });

            this.tickerTimeline.to(this.tickerContainer, {
                duration: 30,
                ease: 'none',
                x: -(this.tickerWidth), // move each box 500px to right
                modifiers: {
                    x: gsap.utils.unitize((x) => parseFloat(x) % this.tickerWidth), // force x value to be between 0 and 500 using modulus
                },
                repeat: -1,
            });

            if (this.scrollTrigger) {
                ScrollTrigger.create({
                    trigger: this.$el,
                    start: 'top bottom',
                    onToggle: (self) => (self.isActive
                        ? this.tickerTimeline.play()
                        : this.tickerTimeline.pause()),
                });
            }

            this.tickerTimeline.play();
        },

        destroyTicker() {
            this.tickerTimeline.kill();
        },

        resetTicker() {
            this.destroyTicker();

            gsap.set(this.tickerContainer, {
                x: 0,
            });
            this.initTicker();
        },
    },

    beforeDestroy() {
        // Destroy the ticker timeline.
        this.destroyTicker();

        // Unlisten.
        EventBus.$off('header-scroll-down', this.setColorStyle);
        EventBus.$off('window-resize', this.resetTicker);
        EventBus.$off('header-scroll-down', this.setColorStyle);
        EventBus.$off('header-scroll-up', this.resetColorStyle);
        EventBus.$off('hero-video-play', this.onVideoPlay);
        EventBus.$off('hero-video-pause', this.onVideoPause);
    },
});
